<template>
  <div
    v-if="$route.name === nome"
    class="container"
  >
    <el-row style="gap: 15px; width: 100%;">
      <template
        v-for="(item, index) in routers"
        :key="index"
      >
        <el-col
          v-if="item && item.meta && item.meta.can && filtroCliente(item.meta.client, item.meta.configCliente ) && ($can(item.meta.can, item.meta.on) || $can('manage', 'all'))"
          :xs="7"
          :sm="6"
          :md="5"
          :lg="5"
          :xl="4"
        >
          <Permite
            :can="item.meta.can"
            :on="item.meta.on"
          >
            <div class="div_routes">
              <router-link
                :to="{ name: item.name }"
                class="el-button el-button--small"
                style="border: 0px"
              >
                <button
                  class="el-button  button-rotas"
                  style="border: 0px"
                >
                  <font-awesome-icon
                    :icon="item.meta.icon"
                    size="3x"
                    :class="styleBlack ? 'el-button--default el-card' : 'el-button--primary el-card'"
                    :style="{ color: 'white', backgroundColor: '#2d80de', borderRadius: '5px', padding: '4px' }"
                  />
                  <div style="padding: 10px; font-size: 11px; white-space: normal; height: 20px">
                    {{ item.meta.breadcrum.replace('{Cliente}', currentClient()) }}
                  </div>
                </button>
              </router-link>
            </div>
          </Permite>
        </el-col>
      </template>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'pinia';
import { loginStore } from 'operass-spa/src/app/login/vuex/index';
// import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

export default {
  name: 'Grid',
  // components: { FontAwesomeIcon },
  props: {
    nome: {
      type: String,
      required: true,
    },
    routers: {
      type: Array,
      required: true,
    },
    styleBlack: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    /* mapeamento acoes vuex */
    ...mapGetters(loginStore, ['currentClient']),

    /**
    * Filtro de permissao para os clientes do sistema
    *
    * @argument clientes os clientes da rota
    */
    filtroCliente(clientes, configCliente) {
      if (!clientes && !configCliente) return true;
      if (!clientes && configCliente) return this.$config.isVisible(configCliente);
      if (clientes && !configCliente) return clientes.includes(this.currentClient());
      return clientes.includes(this.currentClient()) && this.$config.isVisible(configCliente);
    },
  },
};
</script>
<style scoped>

  .el-button  {
    text-decoration: none;
    border: 0;
    padding: 0px;
    height: 0px;
  }

  .button-rotas {
     color: 'white';
    border-radius: 5px;
    padding: 0px;
    display: flex;
    flex-direction: column;
  }

  .div_routes{
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    height: 90px;
    width: 100%;
  }

  .div_routes a{
    padding: 10px;
    width: auto;
    height: 100%;
  }

</style>
